"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledInputPresentationContainer = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _base = _interopRequireDefault(require("../../style/themes/base"));

var _inputSizes = _interopRequireDefault(require("./input-sizes.style"));

var _input = _interopRequireDefault(require("./input.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const StyledInputPresentationContainer = _styledComponents.default.div`
  flex: 0 0 ${({
  inputWidth
}) => inputWidth}%;
  display: flex;
  position: relative;
`;
exports.StyledInputPresentationContainer = StyledInputPresentationContainer;
const InputPresentationStyle = _styledComponents.default.div`
  align-items: stretch;
  background: #fff;
  border: 1px solid ${({
  theme
}) => theme.colors.border};
  box-sizing: border-box;
  cursor: text;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin: 0;
  min-height: ${({
  size
}) => _inputSizes.default[size].height};
  padding-left: ${({
  size
}) => _inputSizes.default[size].horizontalPadding};
  padding-right: ${({
  size
}) => _inputSizes.default[size].horizontalPadding};

  ${_input.default} {
    &:-webkit-autofill {
      margin-top: 2px;
    }
  }

  ${({
  disabled,
  theme
}) => disabled && (0, _styledComponents.css)`
      background: ${theme.disabled.input};
      border-color: ${theme.disabled.border};
      cursor: not-allowed;
    `}

  ${({
  hasFocus,
  theme
}) => hasFocus && (0, _styledComponents.css)`
      && {
        outline: 3px solid ${theme.colors.focus};
        z-index: 2;
      }
    `}

  ${stylingForValidations}

  ${({
  readOnly,
  theme
}) => readOnly && (0, _styledComponents.css)`
      background-color: ${theme.readOnly.textboxBackground};
      border-color: ${theme.readOnly.textboxBorder};
    `}

  ${({
  align
}) => align === "right" && "flex-direction: row-reverse"}

  input::-ms-clear {
    display: none;
  }
  input::-webkit-contacts-auto-fill-button {
    display: none !important;
  }
`;

function stylingForValidations({
  theme,
  error,
  warning,
  info,
  disabled
}) {
  let validationColor;

  if (disabled) {
    return "";
  }

  if (error) {
    validationColor = theme.colors.error;
  } else if (warning) {
    validationColor = theme.colors.warning;
  } else if (info) {
    validationColor = theme.colors.info;
  } else {
    return "";
  }

  return (0, _styledComponents.css)`
    border-color: ${validationColor} !important;
    z-index: 1;
    ${error && `box-shadow: inset 1px 1px 0 ${validationColor}, inset -1px -1px 0 ${validationColor};`}
  `;
}

InputPresentationStyle.safeProps = ["align", "disabled", "hasFocus", "inputWidth", "readOnly", "size", "error", "warning", "info"];
InputPresentationStyle.defaultProps = {
  inputWidth: 100,
  size: "medium",
  theme: _base.default
};
InputPresentationStyle.propTypes = {
  align: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  hasFocus: _propTypes.default.bool,
  inputWidth: _propTypes.default.number,
  readOnly: _propTypes.default.bool,
  size: _propTypes.default.oneOf(["small", "medium", "large"]),
  error: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  warning: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  info: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string])
};
var _default = InputPresentationStyle;
exports.default = _default;